var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-progress d-flex align-items-center"},[_c('div',{staticClass:"download-progress__track small my-2 flex-grow-1"},[_c('div',{staticClass:"download-progress__bar",style:({ width: _vm.displayedPerc + '%' })})])])}
var staticRenderFns = []

export { render, staticRenderFns }